<template>
  <Card :bordered="false" class="message-content-card fullheight pos-relative">
    <div slot="title" class="message-info">
      <Row v-if="message">
        <i-col flex="60px" class="pos-relative" style="margin-right:10px">
          <Avatar v-if="message.user && message.user[0].avatar" :src="message.user[0].avatar" size="50" class="v-centered"/>
          <Avatar v-else icon="ios-person" size="50" class="v-centered"/>
        </i-col>
        <i-col flex="auto">
          <p v-if="message.user && message.user[0].industry"><b>Anonymous ({{ message.user[0].industry }})</b></p>
          <p v-else><b>{{ message.user[0].username }}</b></p>
          <p style="color:#65aefb;">{{ message.rfp_number }}</p>
          <p>Subject : {{ message.subject }}</p>
        </i-col>
      </Row>
    </div>
    <div class="messages-replies fullheight pos-relative">
      <div class="replied-messages">
        <RfpsMessageReplies :messages="messages"/>
        <Spin fix v-if="isLoading"></Spin>
      </div>
      <div class="reply-section">
        <p class="text-right"><small v-if="isSending">Sending...</small></p>
        <p v-if="attachedFilename" style="background:#ffffff;" class="text-right">
          <small>
            <i><Icon type="md-attach" style="transform: rotate(50deg);"/> {{attachedFilename}}</i>
            <Icon type="md-trash" color="#ed4014" style="margin-left:5px;" class="clickable" @click="handleRemoveAttachedFile"/>
          </small>
        </p>
        <Input v-model="replyMessage" size="large" class="reply-input" :readonly="(isSending)? true:false">
          <UploadFile slot="suffix" class="attach-file" @upload="handleAttachedFile" :maxSize="102400" :format="['pdf']">
            <Icon slot="content" type="md-attach" class="attach-file clickable" size="25"/>
          </UploadFile>
          <Icon type="md-send" slot="suffix" class="reply-send clickable" @click="handleSendRfpMessage" :style="(isSending)? 'background:#968a8a':''"/>
        </Input>
      </div>
    </div>
  </Card>
</template>

<script>
import { fetchRfpMessagesByRfp, sendRfpMessage } from '@/services/rfps-messages'
import RfpsMessageReplies from './RfpsMessageReplies'
import UploadFile from '@/components/ui/UploadFile'

export default {
  components: {
    RfpsMessageReplies,
    UploadFile
  },

  props: {
    message: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      messages: [],
      backendBaseUrl: process.env.VUE_APP_URL,
      replyMessage: null,
      isSending: false,
      isLoading: false,
      attachedFile: '',
      attachedFilename: null
    }
  },

  watch: {
    message: {
      handler (val) {
        this.resetData()
        this.message = val
        this.getRfpConverstions()
      },
      deep: true
    }
  },

  mounted () {
    this.getRfpConverstions()
  },

  methods: {
    getRfpConverstions () {
      this.isLoading = true
      this.attachedFile = ''
      this.attachedFilename = null
      fetchRfpMessagesByRfp(this.message.id, this.message.company.company_id).then(res => {
        this.messages = res.data
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to get rfp exchange messages: ', err)
        this.isLoading = false
      })
    },

    handleSendRfpMessage () {
      this.isSending = true

      const data = {
        company_receiver: this.message.company.company_id,
        receiver: this.message.user[0].id,
        rfp: this.message.id,
        message: this.replyMessage,
        file: this.attachedFile,
        file_name: this.attachedFilename
      }

      sendRfpMessage(data).then(res => {
        this.getRfpConverstions()
        this.$Message.success('Sent')
        this.resetData()
        this.attachedFile = ''
        this.attachedFilename = null
        this.isSending = false
      }).catch(err => {
        console.log('Failed to send rfp message: ', err)
        this.isSending = false
      })
    },

    handleAttachedFile (file, name) {
      this.attachedFile = file
      this.attachedFilename = name
    },

    resetData () {
      this.messages = []
      this.replyMessage = ''
      this.attachedFile = ''
    },

    handleRemoveAttachedFile () {
      this.attachedFile = ''
      this.attachedFilename = null
    }
  }
}
</script>

<style lang="scss" scoped>
.message-content-card {
  overflow: hidden;
  background: #ffffff;
  .message-info {
    background: $secondaryLight;
    padding: 20px;
    p {
      color: #ffffff;
    }
  }
  .messages-replies {
    .replied-messages {
      height: calc(100% - 50px);
      overflow-y: scroll;
      overflow-x: hidden;
      overflow: auto;
    }
    .reply-section {
      position: absolute;
      bottom: 0px;
      width: 100%;
      height: 50px;
    }
  }
}
</style>

<style lang="scss">
.message-content-card {
  .ivu-card-head {
    padding: 0px;
  }
  .ivu-card-body {
    height: calc(100% - 150px);
    position: relative;
    padding: 0px;
    margin: 20px;
  }
  .messages-replies {
    .reply-section {
      .reply-input {
        .ivu-input.ivu-input-large {
          height: 50px;
        }
        .ivu-input-suffix {
          width: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          .reply-send {
            background: $primary;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            color: #ffffff;
            &:before {
              margin-left:5px;
            }
          }
          .attach-file {
            margin-right: 5px;
            transform: rotate(15deg);
          }
        }
        .ivu-input-with-suffix {
          padding-right: 100px;
        }
      }
    }
  }
}
</style>
